import { number } from 'yup';
import DTOEmpleado from '../../Componest/Catalogos/CatEmpleados/DTO/DTOEmpleado'
import http from '../common/http-common'
import DTOEmpleadoVac from '../../Componest/Catalogos/CatEmpleados/DTO/DTOEmpleadoVac';
import { get } from 'node:http';
import DTOFirmasResponse from '../../DTO/Reportes/DTOFirmasResponse';
import DTOEsHomeOffice from '../../DTO/DTOEsHomeOffice';

import DTOEmpleadoResponse from '../../Componest/Catalogos/CatEmpleados/DTO/DTOEmpleadoResponse';
import {
  DTOEmpleadoInfoGeneral,
  DTOEmpleadoInfoGeneralDetalle,
  DTOGuardarEmpleadoInfoGeneral,
  DTOActualizarEmpleadoInfoGeneral,
} from '../../Componest/Catalogos/CatEmpleados/DTO/DTOEmpleadoInfoGeneral';

class CatEmpleados {

 GetInfoGeneral(numEmpleado: string) {
   return http.get<DTOEmpleadoInfoGeneralDetalle>(
     '/Catalogos/CatalogoEmpleado/GetInfoGeneral',
     { params: { numEmpleado } }
   )
 }

 CrearVigenciaInfoGeneral(data: DTOGuardarEmpleadoInfoGeneral) {
   return http.post<DTOEmpleadoInfoGeneral>(
     '/Catalogos/CatalogoEmpleado/CrearVigenciaInfoGeneral',
     data
   )
 }

 ActualizarInfoGeneral(data: DTOActualizarEmpleadoInfoGeneral) {
   return http.post<DTOEmpleadoInfoGeneral>(
     '/Catalogos/CatalogoEmpleado/ActualizarInfoGeneral',
     data
   )
 }

 GetAllEmpleado() 
 {
    return http.get<DTOEmpleado[]>('/Catalogos/CatalogoEmpleado/GetAllEmpleado')
 }


 
  GetEmpleadosSistemas() {
    return http.get<DTOEmpleado[]>('/Catalogos/CatalogoEmpleado/GetEmpleadosSistemas')
  }



  CompletarAltaSistemas(data: any) {
    return http.post<DTOEmpleadoResponse>('/Catalogos/CatalogoEmpleado/CompletarAltaSistemas', data)
  }


  
GetSuperFirma(numEmpleado: string )
{
  return http.get<DTOFirmasResponse>('Catalogos/CatalogoEmpleado/GetSupervisorFirma', {params: {numEmpleado: numEmpleado}} )
} 





PostInsertUpdate(data: any) {
  return http.post<DTOEmpleadoResponse>('/Catalogos/CatalogoEmpleado/InsertUpdate', data)
}




DeleteEmpleado(NumEmpleado: string, comentarios?: string) {
  return http.delete<DTOEmpleadoResponse>('/Catalogos/CatalogoEmpleado/Delete', {
    params: {
      NumEmpleado,
      comentarios 
    }
  })
}










  GetIdEmpleado(id: number) {
    return http.get<DTOEmpleadoVac[]>(`/Catalogos/CatalogoEmpleado/GetIdEmpleado`, {
      params: {
        id: id  
      }
    });
  }





  GetIdSupervisor(IdSupervisor : string) {
    return http.get<DTOEmpleadoVac[]> (`/Catalogos/CatalogoEmpleado/GetEmpleadoSupervisor`,   {
      params: {
        IdSupervisor: IdSupervisor
      }
    })
  }

  

  SaveFotoFirma(numEmpleado: string, foto: File | null, firma: File | null) {
    const formData = new FormData();
    
    
    formData.append("NumEmpleado", numEmpleado);
    if (foto) formData.append("Foto", foto);
    if (firma) formData.append("Firma", firma);
    
    
    return http.post("/Catalogos/CatalogoEmpleado/SaveFotoFirma", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
  
  
  
 
  
  GetFotoFirma(id: string, tipo: 'foto' | 'firma') {
    return http.get(
      `/Catalogos/CatalogoEmpleado/GenerateFotoFirma/${encodeURIComponent(id)}/${tipo}`,
      { responseType: 'blob' }
    )
      .then((response) => {
        const imageUrl = URL.createObjectURL(response.data);
        return imageUrl;
      });
  }

  GetFotoFirmaBlob(id: string, tipo: 'foto' | 'firma') {
    return http.get<Blob>(
      `/Catalogos/CatalogoEmpleado/GenerateFotoFirma/${encodeURIComponent(id)}/${tipo}`,
      { responseType: 'blob' }
    );
  }


     
    GetEsHomeOffice(numEmpleado: string) {
      return http.get<DTOEsHomeOffice>('/Catalogos/CatalogoEmpleado/EsEmpleadoHomeOffice', {
        params: {
          numEmpleado: numEmpleado
        }
      });
    }


  AltaEmpleadoConFotoOpcional(data: any, fotoCorreo?: File | null) {
  const formData = new FormData()

  formData.append('IdEmpNo', String(data.idEmpNo ?? 0))
  formData.append('Ac', String(data.ac ?? 0))
  formData.append('Name', data.name ?? '')
  formData.append('NumEmpleado', data.numEmpleado ?? '')
  formData.append('Departamento', data.departamento ?? '')
  formData.append('Puesto', data.puesto ?? '')
  formData.append('HoraEntrada', data.horaEntrada ?? '')
  formData.append('HoraSalida', data.horaSalida ?? '')
  formData.append('Activo', String(data.activo ? 1 : 0))
  formData.append('Payroll', data.payroll ?? '')
  formData.append('Oficina', data.oficina ?? '')
  formData.append('HoraSalidaComer', data.horaSalidaComer ?? '')
  formData.append('HoraEntradaComer', data.horaEntradaComer ?? '')
  formData.append('FechaIngreso', data.fechaIngreso ?? '')
  formData.append('Modalidad', data.modalidad ?? '')
  formData.append('TipoAccion', data.tipoAccion ?? '')
  formData.append('Comentarios', data.comentarios ?? '')
  formData.append('AltaEnSistemas', String(data.altaEnSistemas ?? false))
  formData.append('CorreoElectronicoEmpresa', data.correoElectronicoEmpresa ?? '')
   formData.append('IdSupervisorCatalogo', data.idSupervisorCatalogo ? String(data.idSupervisorCatalogo) : '')


  if (data.fechaAltaRelojAccesos) {
    formData.append('FechaAltaRelojAccesos', data.fechaAltaRelojAccesos)
  }

  if (data.fechaBajaEfectiva) {
    formData.append('FechaBajaEfectiva', data.fechaBajaEfectiva)
  }

  if (data.fechaBajaAccesosReloj) {
    formData.append('FechaBajaAccesosReloj', data.fechaBajaAccesosReloj)
  }

  if (data.fechaBajaSistemas) {
    formData.append('FechaBajaSistemas', data.fechaBajaSistemas)
  }

  if (fotoCorreo) {
    formData.append('FotoCorreo', fotoCorreo)
  }

  return http.post<DTOEmpleadoResponse>(
    '/Catalogos/CatalogoEmpleado/AltaEmpleadoConFotoOpcional',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
}


}









export default new CatEmpleados()
